import Vue from 'vue'
import axios from 'axios'

const DROPBOX_API = axios.create({
  baseURL: process.env.VUE_APP_DROPBOX_URL,
  headers: {
    'Content-Type': 'application/json',  //application/octet-stream',
    'Authorization': 'Bearer ' + process.env.VUE_APP_DROPBOX_ACCESS_TOKEN,
  }
})

export default Vue.prototype.$dropbox = DROPBOX_API;


